import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be57c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-container" }
const _hoisted_2 = { class: "operation-bar" }
const _hoisted_3 = { class: "application-detail" }
const _hoisted_4 = { class: "base-info" }
const _hoisted_5 = { class: "key" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "key" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "config-info" }
const _hoisted_10 = { class: "config-title" }
const _hoisted_11 = { class: "config-content" }
const _hoisted_12 = {
  key: 0,
  class: "config-item"
}
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回调API", -1 /* HOISTED */))
const _hoisted_15 = {
  key: 0,
  class: "sub-key"
}
const _hoisted_16 = { class: "sub-key-title" }
const _hoisted_17 = { class: "card-header" }
const _hoisted_18 = {
  key: 0,
  class: "sub-key"
}
const _hoisted_19 = { class: "sub-key-title" }
const _hoisted_20 = { class: "base-info" }
const _hoisted_21 = { class: "key-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "状态", -1 /* HOISTED */))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "key-value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "创建时间", -1 /* HOISTED */))
const _hoisted_26 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _ctx.$router.back
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addVisible = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("新增配置")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.baseVisible = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("编辑")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.APP_BASE_INFO, (value, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "key-value"
          }, [
            (key === 'hasVOIP')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(value), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, _toDisplayString($props.application[key] ? '是' : '否'), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(value), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_8, _toDisplayString($props.application[key]), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configs, (config, configKey) => {
          return (_openBlock(), _createElementBlock("div", {
            key: configKey,
            class: "config-item"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.CONFIG_TYPES.get(configKey as string) || ''), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_11, [
              (configKey === 'callbackUrls')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      style: {"width":"360px"}
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", null, [
                            _createVNode($setup["Edit"], {
                              style: {"margin-right":"8px","color":"#409eff"},
                              onClick: ($event: any) => ($setup.handleEdit(config, configKey))
                            }, null, 8 /* PROPS */, ["onClick"]),
                            _createVNode($setup["Delete"], {
                              style: {"margin-right":"8px","color":"#f56c6c"},
                              onClick: ($event: any) => ($setup.handleDelete(config, configKey))
                            }, null, 8 /* PROPS */, ["onClick"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (item.url)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.callbackUrlType === 1 ? '通知用户在线状态' : '通知语音通话状态'), 1 /* TEXT */),
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: item.url,
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_text, {
                                        class: "callback-url",
                                        truncated: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.url), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content"])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(config, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "config-item"
                    }, [
                      ($setup.showVoipItem(item.configType, item.pushPlateform))
                        ? (_openBlock(), _createBlock(_component_el_card, {
                            key: 0,
                            shadow: "hover",
                            style: {"width":"360px"}
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", null, _toDisplayString($setup.judgePushType(configKey as string, item.configType, item.pushPlateform)), 1 /* TEXT */),
                                _createElementVNode("div", null, [
                                  _createVNode($setup["Edit"], {
                                    style: {"margin-right":"8px","color":"#409eff"},
                                    onClick: ($event: any) => ($setup.handleEdit(config, configKey as string, index))
                                  }, null, 8 /* PROPS */, ["onClick"]),
                                  _createVNode($setup["Delete"], {
                                    style: {"color":"#f56c6c"},
                                    onClick: ($event: any) => ($setup.handleDelete(config, configKey as string, index))
                                  }, null, 8 /* PROPS */, ["onClick"])
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.SUB_KEYS, (subValue, subKey) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: subKey }, [
                                  (item[subKey])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(subValue), 1 /* TEXT */),
                                        _createVNode(_component_el_tooltip, {
                                          effect: "dark",
                                          content: item[subKey],
                                          placement: "top"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_text, { truncated: "" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item[subKey]), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content"])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(!$props.application.status ? '正常' : '禁用'), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$filters.dateFormat($props.application.creationDate)), 1 /* TEXT */)
        ])
      ])
    ]),
    _createVNode($setup["AddConfig"], {
      "add-visible": $setup.addVisible,
      "app-info": $setup.appInfo,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.addVisible = false)),
      onConfirm: $setup.handleConfirm
    }, null, 8 /* PROPS */, ["add-visible", "app-info"]),
    _createVNode($setup["EditConfig"], {
      "edit-visible": $setup.editVisible,
      title: $setup.editTitle,
      "edit-Key": $setup.editKey,
      data: $setup.editData,
      "app-info": $setup.appInfo,
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.editVisible = false)),
      onSave: $setup.handleSaveEdit
    }, null, 8 /* PROPS */, ["edit-visible", "title", "edit-Key", "data", "app-info"]),
    _createVNode($setup["EditBaseInfo"], {
      "base-visible": $setup.baseVisible,
      "base-info": $setup.appInfo,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.baseVisible = false)),
      onSave: $setup.handleSaveBaseInfo
    }, null, 8 /* PROPS */, ["base-visible", "base-info"])
  ]))
}